export const SIGNUP_REQUEST = 'SignupPage/SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SignupPage/SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SignupPage/SIGNUP_FAILURE';
export const CLEAR_ERROR = 'SignupPage/CLEAR_ERROR';
export const CLEAR_STATE = 'SignupPage/CLEAR_STATE';
